import { RevocationMajorityIntl } from './types';

export const revocationMajorityOptions: { label: RevocationMajorityIntl; value: string }[] = [
  { label: 'UNANIMITY', value: 'UNANIMITY' },
  { label: 'MAJORITY_2_THIRD', value: 'MAJORITY_2_THIRD' },
  { label: 'MAJORITY_VOICE', value: 'MAJORITY_VOICE' },
];
